import { render, staticRenderFns } from "./TableSortControl.vue?vue&type=template&id=05ea700d&"
import script from "./TableSortControl.vue?vue&type=script&lang=js&"
export * from "./TableSortControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports